import { useState } from 'react';
import { useApi } from '#shared/providers/Api';
import toPartnerAccountTransactionsRequest, {
  PartnerTransactionsHistoryRequest,
} from './toPartnerAccountTransactionsRequest.helper';
import toTransactionsHistoryResponse from './toTransactionsHistoryResponse.helper';

// The Transaction History fetch for a partner account's whole book (ID-13796): `/partner/account/transactions`
// through `api.fetchPartnerAccountTransactions`, which the host's api signs as that partner account. Same
// contract as useFetchTransactionsHistory, so the list reads either; the route takes only some of the shared
// filters, under its own names, and returns rows in its own shape, which the two helpers translate. Logs
// once and rethrows; the caller surfaces the error.
export default function useFetchPartnerTransactionsHistory() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  async function fetchTransactionsHistory(req: PartnerTransactionsHistoryRequest) {
    try {
      setFetching(true);

      const raw = await api.fetchPartnerAccountTransactions(toPartnerAccountTransactionsRequest(req));

      if (!raw.Success) throw new Error(raw.ErrorMessage);

      const res = toTransactionsHistoryResponse(raw);

      setTotalRecords(res.PaginationMetaData.TotalRecords);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, totalRecords, fetchTransactionsHistory };
}
